const download = (source: any) => {
  var el = document.createElement("a")
  el.setAttribute("href", source)
  el.setAttribute("download", "MinecraftSkin.png")
  document.body.appendChild(el)
  el.click()
  el.remove()
}

export default download
